//Action Types
export const SET_SIDEBAR_OPENED = 'SET_SIDEBAR_OPENED';

export const setSidebarOpened = payload => ({
    type: SET_SIDEBAR_OPENED,
    payload,
});
